import { useParams } from 'react-router-dom';

import { useApiQuery } from 'shared/hooks/useApiQuery';

const useIntegrationSellerOverviewPage = () => {
  const { sellerId } = useParams();

  const { data: markdown = null, isLoading: loading } = useApiQuery(
    ['integrationOverviewMarkdown'],
    () =>
      fetch('/IntegrationOverview.md').then((res) => {
        if (!res.ok) throw new Error('Failed to load integration overview');
        return res.text();
      }),
    {
      staleTime: Infinity,
      cacheTime: 30 * 60 * 1000,
    },
  );

  return {
    sellerId,
    markdown,
    loading,
  };
};

export default useIntegrationSellerOverviewPage;
